import React, { useState, useEffect } from 'react'
import { useLocalStorage } from 'react-use'
import { applyBranding } from '../helpers/branding_utils'
import { WhitelabelBranding } from '../model'
import { getBranding } from '../services/api/whitelabel'
import { updateContrastColors } from '../utils/colorUtils'
import { DEFAULT_BRANDING } from '../helpers/constants'

const initialContext: {
    value: any
    setValue(data: any): void
    remove(): void
    brand: WhitelabelBranding | null
    isLoading: boolean
} = {
    value: { user: null, deliveries: null },
    setValue: (data: any) => {},
    remove: () => {},
    brand: null,
    isLoading: true
}

export const TibiContext = React.createContext(initialContext)

export const TibiContextProvider = ({ storageKey, children }: { storageKey: string; children: any }) => {
    const [value, setValue, remove] = useLocalStorage(storageKey)
    const [brand, setBrand] = useState<WhitelabelBranding | null>(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        // Load branding data
        const loadBranding = async () => {
            let response: WhitelabelBranding = await Promise.resolve(DEFAULT_BRANDING)
            try {
                const res = await getBranding(window.location.hostname)
                response = res.data
            } catch (error) {
                console.error('Failed to load branding:', error)
            } finally {
                setBrand(response)
                await applyBranding(response)
                updateContrastColors()
                setIsLoading(false)
            }
        }
        loadBranding()
    }, [])

    return (
        <TibiContext.Provider
            value={{
                value,
                setValue,
                remove,
                brand,
                isLoading
            }}
        >
            {!isLoading && children}
        </TibiContext.Provider>
    )
}
